import GlobalChannelSettingsProvider from "./GlobalChannelSettingsProvider";
import ImageAnnotationSidebar from "./ImageAnnotationSidebar";
import O from "./O";
import ImageCroppingContainerToolbar from "./ImageCroppingContainerToolbar";
import React from "react";
import { useCallback, useState, useEffect } from 'react'
import { debounce } from './utils';

import { useDispatch, useSelector } from 'react-redux';
import CropPreviewContainer from './CropPreviewContainer';
import G from './Getters';
import A from './ActionCreators';
import Tooltip from '@material-ui/core/Tooltip';

import CroppableImage from './CroppableImage';

import {FocusedAnnotationContext,  DrawingContext, AnnotationStyleContext, FigureChannelAdjustmentContext } from './Contexts';

const bounds = (ref) => ref.current.getBoundingClientRect();

const p = (arg) => {
  if (arg instanceof Object) {
    let newObj = {};
    Object.keys(arg).forEach((key) => (newObj[key] = p(arg[key])));
    return newObj;
  } else {
    return arg + "px";
  }
};


;

const drawingToolMap = ['band','box','fixedRatio','upright'];

const regionChoiceModeMap = ({
  "regionChoice":3,
  "insertImage":3
})





function provideSetFocusedAnnotationIdHookGloballyForTutorial(hookFunction){
  window.__setFocusedAnnotationId = hookFunction;
}

export default function ImageCroppingContainer({
  atnIdList,
  selectedImageId,
  referenceAnnotationId,
  src,
  showSidebar,
  imageManagementWidth,
  mode,
  onEventMap,
  toolbar,
  imageToRender,
  onEvent,
  nextButton,
}) {



  let dispatch = useDispatch();

  



  const [ selectedDrawingToolId, setSelectedDrawingToolId ] = useState(
    regionChoiceModeMap[mode] || 0
  )

  const [temporaryAdjustments, setTemporaryAdjustments] = useState({});


  const [ focusedAnnotationId, _setFocusedAnnotationId ] = useState();


  provideSetFocusedAnnotationIdHookGloballyForTutorial(_setFocusedAnnotationId);


  let [temporaryAnnotationProperties,setTemporaryAnnotationProperties] = useState({});


  const setFocusedAnnotationId = arg => {
    let t = temporaryAnnotationProperties;

    _setFocusedAnnotationId(arg)
    if( Object.keys(t).length > 0 ){

      dispatch(A.setAnnotationProperties({
        _id:focusedAnnotationId,
        ...temporaryAnnotationProperties
      }))

    }
  }


  let { crop, imageSet, imageSetId, imageId, image, atns } = useSelector(state => {
    let crop;
    let imageSet;
    let imageSetId;
    let imageId;
    let image;
    let atns;

    if( !selectedImageId && referenceAnnotationId && !referenceAnnotationId.includes('v_') ){
      crop = G.getCropFromAnnotation(state,referenceAnnotationId)
      imageSetId = G.getImageSetIdByAnnotationId(state,{_id:referenceAnnotationId});
      imageSet = G.getImageSet(state,imageSetId);
      imageId = G.getImageSetFigureImageIdByAnnotationId(state,{annotationId:referenceAnnotationId});

      if( !imageId ){
        debugger;
        imageId = G.getImageSetFigureImageIdByAnnotationId(state,{annotationId:referenceAnnotationId});

      }

      image = G.getData(state,{itemType:'imageUploads',_id:imageId});
      atns = G.getRelativeLsAnnotationsBoundedByAnnotationId(state,{annotationId:referenceAnnotationId});

    }else{




      if( !selectedImageId ){
        imageId = G.getImageSetFigureImageIdByAnnotationId(state,{annotationId:referenceAnnotationId});
      }else{
        imageId = selectedImageId;
      }

      image = G.getData(state,{itemType:'imageUploads',_id:imageId});
      let { height } = image;

      crop = { 
        top:0, 
        left: 0, 
        width:1, 
        height, 
        rotation:0 
      }


      imageSetId = G.getImageSetIdByImageId(state,imageId);
      imageSet = G.getImageSet(state,imageSetId);
      atns = G.getAnnotationsByImageSetId(state,imageSetId);


    }

    return { 
      imageSet,
      crop, 
      imageSetId,
      imageId,
      image,
      atns
    }
  });



  useEffect(() => {
    setFocusedAnnotationId(undefined);
  },[imageSetId])


  useEffect(() => {
    setTemporaryAnnotationProperties({});

  },[focusedAnnotationId])

  useEffect(() => {
    if( !focusedAnnotationId ){
      setFocusedAnnotationId(null);
    }
  },[imageSetId])

  const notifyAnnotationPropertyChange = change => {
    setTemporaryAnnotationProperties({
      ...temporaryAnnotationProperties,
      ...change
    })
  }



  const imgContainerRef = React.useRef(null);
  const imgRef = React.useRef(null);


  const [windowResizeMarker,setWindowResized] = React.useState(0);

  useEffect(() => {
    setWindowResized(!windowResizeMarker);
  },[imageManagementWidth])

  const onResize = () => {
    setWindowResized(!windowResizeMarker);
  }

  React.useEffect(() => {
    window.addEventListener('resize',onResize);

    return () => {
      window.removeEventListener('resize',onResize);
    };
  });

  const [ selectedItemIds, setSelectedItemIds ] = React.useState([]);


  const onClick = (e) => {
    let path = e.composedPath();
    let tagsToIgnoreForUnselection = ["INPUT", "SELECT", "BUTTON"];


    if (!tagsToIgnoreForUnselection.includes(path[0].tagName)) {
      setSelectedItemIds([]);
    }
  };

  React.useEffect(() => {
    window.addEventListener("click", onClick);
    return () => {
      window.removeEventListener("click", onClick);
    };
  });

  const HtmlTooltip = ({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  )



  const [ guidelineSpec, setGuidelineSpec ] = useState({w:1,h:1});




  let defaultSidebar = (
    <ImageAnnotationSidebar {...{
      mode,
      atns,
      temporaryAnnotationProperties,
      imageId,
      notifyAnnotationPropertyChange,
      imgRef,
      imageSetId, 
      labelEditable:false,
      crop,
      cropListMode:(mode==="insertImage"?"list":null)
    }}/>

  )




  

  


  let croppableImage = (

    <CroppableImage {
      ...{
        interactive:true,
          atns:(atnIdList || atns),
          temporaryAdjustments:{
            ...image.adjustments,
              ...temporaryAdjustments,
          },
          guidelineType:drawingToolMap[selectedDrawingToolId],
          notifyAnnotationPropertyChange,
          temporaryAnnotationProperties,
          imgContainerRef, 
          imgRef, 
          src,
          selectedItemIds,
          imageSetId,
          imageId,
          crop,
          imageToRender,
          onEvent,
          extraContainerStyle: {
            background:'rgba(238,238,238)',
          },
      }}/>

  );

  const onAdjustments = useCallback(debounce(adjChannels => {

    let adjustments = adjChannels.default ?? {};

    if (imageId != null) {
      dispatch(A.setImageProperties({
        imageId,
        properties:{
          adjustments
        }
      }))
    }
  }, 500), [dispatch, imageId]);

  const defaultAdjustments = { "default": image.adjustments };

  return (


    <GlobalChannelSettingsProvider 
      key={imageId}
      onChange={onAdjustments} 
      defaultAdjustments={defaultAdjustments}>
    <FocusedAnnotationContext.Provider value={{focusedAnnotationId,setFocusedAnnotationId}}>

    <div style={{
      minWidth:0,
      minHeight:0,
    }} class="flex-expand sg-col rel full-height">

      {false && <div style={{ top:0, position:'absolute', }}>{selectedImageId}</div>}
      <DrawingContext.Provider value={{
        allowedAnnotationTypes:( mode && ["ls","rect"] ),
        guidelineType:drawingToolMap[selectedDrawingToolId],
        guidelineSpec,
      }}>
        <div class="sg-col flex-expand rel" style={{
          minHeight:0,
          minWidth:0,
          //width:'100%',
          //height:'100%',
          // overflow:'hidden',
        }}>

          {mode !=="viewOnly" && <ImageCroppingContainerToolbar {...{
            mode,
              selectedDrawingToolId,
              setSelectedDrawingToolId,
              image,
              imageId,
              temporaryAdjustments,
              setTemporaryAdjustments,
              toolbar,
              nextButton,
          }}/>}


          <div id="annotate-images-container" 
            class="flex-expand sg-row"
            style={{

              borderTop:'1px solid #ccc',
              height:'100%',
              maxHeight:'100%',

            }}>

            {croppableImage}

            {defaultSidebar}




          </div>





        </div>
      </DrawingContext.Provider>
    </div>
    </FocusedAnnotationContext.Provider>
    </GlobalChannelSettingsProvider>
  );
}


